'use client';

import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface HeroSectionProps {
  onGetStarted?: () => void;
}

const HeroSection = ({ onGetStarted }: HeroSectionProps) => {
  return (
    <section className="relative bg-gradient-to-br from-primary/5 via-background to-secondary/5 pt-32 pb-20 lg:pt-40 lg:pb-28">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 rounded-full mb-6">
              <Icon name="ShieldCheckIcon" size={20} className="text-primary" />
              <span className="text-sm font-medium text-primary">HIPAA Compliant & Secure</span>
            </div>
            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-heading font-bold text-foreground mb-6 leading-tight">
              Healthcare That Comes to You
            </h1>
            <p className="text-lg lg:text-xl text-muted-foreground mb-8 max-w-2xl mx-auto lg:mx-0">
              Connect with licensed physicians from the comfort of your home. Get personalized treatment plans, prescriptions, and ongoing care—all through our secure telehealth platform.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Link
                href="/health-vertical-pages"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-primary text-primary-foreground rounded-lg font-semibold text-lg transition-smooth hover:shadow-elevation-lg hover:scale-[0.98] active:scale-[0.96]"
              >
                Get Started Today
                <Icon name="ArrowRightIcon" size={20} />
              </Link>
              <Link
                href="/health-vertical-pages"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-card border-2 border-border text-foreground rounded-lg font-semibold text-lg transition-smooth hover:border-primary hover:bg-muted"
              >
                Browse Conditions
                <Icon name="MagnifyingGlassIcon" size={20} />
              </Link>
            </div>
          </div>
          <div className="relative">
            <div className="aspect-square rounded-2xl bg-gradient-to-br from-primary/20 to-secondary/20 overflow-hidden shadow-elevation-xl">
              <div className="w-full h-full flex items-center justify-center">
                <Icon name="HeartIcon" size={200} className="text-primary/30" variant="solid" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;